export const PageRoutes = {
    shopRegister: {
        map: 'shop-register/map',
        addShop: 'shop-register/shop'
    },
    login: 'login'
};
